import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import MainLayout from './components/layout/MainLayout.vue'
import AuthFormLayout from './components/layout/AuthFormLayout.vue'

// Pages
import indexPage from './pages/indexPage.vue'

const routes: readonly RouteRecordRaw[] = [
  {
    path: '/',
    component: indexPage,
    name: 'indexPage',
    meta: { layout: MainLayout, requiresAuth: true }
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router